<script>
    import {slide} from 'svelte/transition';
    import {createEventDispatcher} from 'svelte';
    import {fade} from 'svelte/transition';
    import {PaginationNav} from 'svelte-paginate';
    import {sgettext} from '../../i18n.js';

    import FailedInstancesCountColumn from "../DashBoard/FailedInstancesCountColumn.svelte";
    import FailedInstanceReasons from '../DashBoard/FailedInstanceReasons.svelte';
    import WorkOrderNumberColumn from "./ColumnRenderers/WorkOrderNumberColumn.svelte";
    import WorkRequestActivityNameColumn from "./ColumnRenderers/WorkRequestActivityNameColumn.svelte";
    import WorkRequestFailureReasonColumn from "./ColumnRenderers/WorkRequestFailureReasonColumn.svelte";
    import DateTimeColumn from "./ColumnRenderers/DateTimeColumn.svelte";
    import BranchColumn from "../DashBoard/BranchColumn.svelte";

    export let dataListRow = false;
    export let showHeader = true;
    export let noHeader = false;
    export let striped = false;
    export let hover = true;
    export let small = false;
    export let showFooter = false;
    export let saving = false;
    export let total = 0;
    export let perPage = 1;
    export let currentPage = 1;
    export let changePage = () => {};
    export let footerColSpan = 1;
    export let schema = {};
    export let onRowClick = (event, row) => {
    };
    export let rowActions = null;
    export let dragMode = '';
    export let aggregatedColumns = null;
    export let sortFunction = () => {
    };
    export let emptyLabel = sgettext('$$NONE$$');
    export let tableId = "";
    export let field = '';
    export let stickyHeader = false;
    export let allInstances = false;
    export let defaultCellValue = '';
    export let tooltip = '';

    let columns = {
        name: {
            label: sgettext("$$CURRENT_ACTIVITIES_FAILED_CONFIGS$$"),
            renderer: WorkRequestActivityNameColumn,
        },
        failed_work_requests: {
            label: sgettext("$$FAILED_CREATE$$"),
            renderer: FailedInstancesCountColumn,
        },
        branch: {
            label: sgettext("$$BRANCH$$"),
            renderer: BranchColumn,
        },
        work_centre: {
            label: sgettext("$$WORK_CENTRE_1$$"),
        }
    };

    let subColumns = {
        number: {
            label: sgettext('$$WORK_ORDER$$'),
            renderer: WorkOrderNumberColumn,
        },
        name: {
            label: sgettext('$$PLANNED_INSTANCE$$'),
        },
        scheduled_start_time: {
            label: sgettext('$$SCHEDULED_EXECUTION$$'),
            renderer: DateTimeColumn,
        },
        reason: {
            label: sgettext('$$FAILURE_REASON$$'),
            tooltip: sgettext('$$CLICK_VIEW_FAILURE_REASON_DETAILS$$'),
            renderer: WorkRequestFailureReasonColumn
        }
    }

    export let rows = [];

    $: showHeader = noHeader? false : rows.length > 0;

    const dispatch = createEventDispatcher();

    let columnKeys = Object.keys(columns);
    let subColumnKeys = Object.keys(subColumns);

    if (changePage) {
        changePage({page: 1});
    }

    function renderColumn(row, columnName, columnList) {
        const obj = getObject(row, columnName, columnList);
        if (obj) {
            let keyPath = columnName;

            if (columnList[columnName].hasOwnProperty('keyPath')) {
                keyPath = columnList[columnName].keyPath;
            }

            return obj[keyPath];
        }
        return defaultCellValue;
    }

    function handleChange(event) {
        dispatch('handleChange', {
            event
        });
    }

    function getObject(row, columnName, columnList) {
        /*
            Retrieve the object given a django-style double__underscore__attribute__name specified as the
            sourceObjectName.

            If no sourceObjectName is specified for the column, the row is simple returned as-is.

            e.g.
            row = {id: 1, inner_row: {id: 56}};

            columns = {
                id: {
                    label: "ID"
                },
                inner: {
                    label: "INNER",
                    sourceObjectName: 'inner_row'
                }
            }

            getObject(row, 'inner')
            > {id: 56}
            getObject(row, 'id')
            > {id: 1, inner_row: {id: 56}}
         */

        let obj = row;

        if (columnList[columnName].hasOwnProperty('sourceObjectName')) {
            let sourceObjectName = columnList[columnName].sourceObjectName;

            for (let attr of sourceObjectName.split('__')) {
                obj = obj[attr];
            }
        }

        return obj;
    }



    function handleActivityRowClicked(event, row){
        row.collapsed = !row.collapsed;
        rows = [...rows];
    }


    let instanceFailureReasonsId = 'instanceFailureReasons';
    function handleFailureReasonsTooltipClicked(event){
        jQuery(`#${instanceFailureReasonsId}`).modal('show');
    }

</script>

<table
  id={tableId}
  transition:fade|local
  class="sw table mb-0 border"
  class:table-sm={small}
  class:table-hover={hover}
  class:table-striped={striped}
>
  {#if showHeader}
    <thead
      class="thead-light"
      style={stickyHeader ? 'position: sticky; top: -1px;' : 'none'}
    >
      <tr>
        {#each columnKeys as header}
          {#if columns[header].min_width}
            <th style={`min-width: ${columns[header].min_width}`}
              >{columns[header].label}</th
            >
          {:else if columns[header].tooltip !== undefined}
            <th style={`width: ${columns[header].width}`}
              >{columns[header].label}
              <i
                class="fa fa-question-circle"
                title={columns[header].tooltip}
              />
            </th>
          {:else}
            <th style={`width: ${columns[header].width}`}
              >{columns[header].label}</th
            >
          {/if}
        {/each}
      </tr>
    </thead>
  {:else}
    <thead>
      <tr>
        <td class="p-0" />
      </tr>
    </thead>
  {/if}
  <tbody>
    {#each rows as row, i (row.id && row.name ? `${row.id}_${row.name}` : i)}
      <tr
        transition:fade|local
        class:datalist-row={dataListRow}
        class:active={'selected' in row && row.selected}
        class:activity-row={true}
        key={row.id ? row.id : i}
        on:click={(event) => handleActivityRowClicked(event, row)}
        style={'border:none;'}
      >
        {#each columnKeys as col}
          <td style={`${columns[col].style}`}>
            {#if columns[col].renderer}
              <svelte:component
                this={columns[col].renderer}
                id={`${col}-${i}`}
                key={columns[col].keyPath ? columns[col].keyPath : col}
                bind:data={row[col]}
                {...columns[col].props}
                defaultValue={defaultCellValue}
                {schema}
                row={getObject(row, col, columns)}
                bind:activity={row}
                on:handleChange={handleChange}
              />
            {:else}
              {renderColumn(row, col, columns)}
            {/if}
          </td>
        {/each}
      </tr>

      {#if row && row.hasOwnProperty('failed_work_requests') && row.collapsed}
        <div transition:slide|local={{ duration: 500 }}>
          {#if row.failed_work_requests}
            <tr style="color: rgb(121,119,119)">
              {#each subColumnKeys as header}
                {#if subColumns[header].min_width}
                  <td style={`min-width: ${subColumns[header].min_width}`}
                    >{subColumns[header].label}</td
                  >
                {:else if subColumns[header].tooltip !== undefined}
                  <td style={`width: ${subColumns[header].width}`}
                    >{subColumns[header].label}
                    <i
                      class="fa fa-question-circle"
                      title={subColumns[header].tooltip}
                      on:click={(event) =>
                        handleFailureReasonsTooltipClicked(event)}
                    />
                  </td>
                {:else}
                  <td style={`width: ${subColumns[header].width}`}
                    >{subColumns[header].label}</td
                  >
                {/if}
              {/each}
            </tr>
          {/if}

          {#each row.failed_work_requests as wr, j}
            <tr
              transition:slide|local={{ duration: 500 }}
              class:datalist-row={dataListRow}
              class:work-request-row={true}
              on:click={(event) => onRowClick(event, wr)}
              style={'border:none;'}
            >
              {#each subColumnKeys as scol}
                <td style={`${subColumns[scol].style}`}>
                  {#if subColumns[scol].renderer}
                    <svelte:component
                      this={subColumns[scol].renderer}
                      id={`${scol}-${j}`}
                      key={subColumns[scol].keyPath
                        ? subColumns[scol].keyPath
                        : scol}
                      bind:data={wr[scol]}
                      {...subColumns[scol].props}
                      defaultValue={defaultCellValue}
                      {schema}
                      row={getObject(wr, scol, subColumns)}
                      activityTaskList={row}
                      bind:workRequest={wr}
                      on:handleChange={handleChange}
                    />
                  {:else}
                    {renderColumn(wr, scol, subColumns)}
                  {/if}
                </td>
              {/each}
            </tr>
          {/each}
        </div>
      {/if}
    {/each}

    {#if rows.length === 0}
      <tr>
        <td>{emptyLabel}</td>
      </tr>
    {/if}
    <slot name="infiniteScroll" />
  </tbody>
  {#if showFooter}
    <tfoot class="bg-gray-300">
      <tr>
        <th colspan={footerColSpan}>
          <span class="custom-nav">
            <PaginationNav
              totalItems={total}
              pageSize={perPage}
              {currentPage}
              limit={1}
              showStepOptions={true}
              on:setPage={(e) => {
                currentPage = e.detail.page;
                changePage(e.detail);
              }}
            />
          </span>
        </th>
      </tr>
    </tfoot>
  {/if}
</table>

<FailedInstanceReasons id={instanceFailureReasonsId} />

<style>
  .custom-nav :global(.pagination-nav) {
    display: flex;
    justify-content: flex-end;
    float: right;
    width: 60%;
    font-weight: 400;
  }

  .custom-nav :global(.option) {
    width: 15%;
    border: 1px solid #ced4da;
    text-align: center;
    cursor: pointer;
    background-color: #e9ecef;
  }

  .custom-nav :global(.option.active) {
    cursor: pointer;
    background-color: #ced4da;
  }

  .custom-nav :global(.option.disabled) {
    opacity: 0.25;
    pointer-events: none;
    cursor: auto;
  }

  .actions {
    text-align: right;
  }

  .actions i {
    cursor: pointer;
  }

  .actions :global(.btn) {
    margin-left: 12px;
  }

  .actions :global(.btn:first-child) {
    margin-left: 0;
  }

  .actions i:hover {
    color: #dd5900;
  }

  .activity-row {
    background-color: rgba(240, 240, 240, 0.5) !important;
  }

  .work-request-row {
    background-color: rgba(255, 255, 255, 0.5) !important;
  }

  .sw.table thead th {
    vertical-align: middle;
  }
</style>
